import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/yanga.webp';
import screenshot_target from '../../../images/letterfunnel/jasperbron.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jasper Bron"
      firstname="Jasper"
      companyname="Yanga"
      competition="Air Up en Waterdrop"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jasperbron.js